// @flow

import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  mb, pt, py, px, pb
} from 'styled-components-spacing';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import theme from '@theme';

export const StyledDialogHeader = styled.h2.attrs({ className: 'dialog-header' })`
  font-weight: bold;
  font-size: 20px;

  display: flex;
  flex-direction: row;

  ${mb(0)}

  ${py(3)}
  ${px(2.5)}

  ${theme.typography.Raleway}

  z-index: 1;

  ${theme.shadows.mediumStrong};

  ${breakpoint('desktop')`
    ${py(0)}
    ${pt(4)}
    ${px(4)}

    ${mb(3)}
    
    box-shadow: none;
    flex-direction: row-reverse;
  `}
`;

export const StyledDialogContent = styled.div.attrs({ className: 'dialog-content' })`
  flex: 1;
  overflow-y: auto;
  flex-direction: column;

  ${pt(3.5)}

  ${breakpoint('desktop')`
    display: flex;
    ${pt(0)}
    ${px(4)}

    ${mb(2)}
  `}
`;

export const StyledDialogFooter = styled.div`
  border-top: 1px solid ${theme.colors.formSeparator};

  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${py(3)}
  ${px(4)}

  button:not(:last-child) {
    margin-right: 10px;
  }

  ${breakpoint('desktop')`
    ${pb(4)}
  `}
`;

export const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  width: 100%;
  height: 100%;
  width: 100vw;
  height: 100vh;

  box-sizing: border-box;

  background: rgba(0, 0, 0, 0.45);

  z-index: 1001;

  ${breakpoint('desktop')`
    ${py(4)}
    overflow: auto;
    justify-content: center;
    align-items: center;
  `}
`;

const SIZE_STYLES = {
  SMALL: css`
    min-width: 400px;
    min-height: 320px;
  `,
  MEDIUM: css`
    min-width: 550px;
    min-height: 440px;
  `,
  LARGE: css`
    min-width: 710px;
    min-height: 560px;
  `,
  X_LARGE: css`
    min-width: 950px;
    min-height: 600px;
  `
};

const SIZE_STYLES_LARGE_DESKTOP = {
  X_LARGE: css`
    min-width: 1100px;
    min-height: 900px;
  `
};

const fsStyles = css`
  min-width: 100%;
  min-height: 100%;
`;

const nonFsStyles = css`
  margin: auto;

  max-width: calc(100vw - 40px);

  ${theme.borderRadius.mediumLarge};
  ${theme.shadows.mediumStrong};

  height: ${({ size }) => (size === 'SMALL' ? 'auto' : 'calc(100% - 65px)')};
  ${({ size }) => size === 'SMALL' && 'max-height: calc(100% - 65px);'}
`;

export const StyledDialog = styled.div`
  z-index: 110;

  display: flex;
  overflow: hidden;
  flex-direction: column;

  background: ${theme.colors.white};

  ${({ size }) => (size === 'SMALL' ? nonFsStyles : fsStyles)}

  ${breakpoint('desktop')`
    ${({ size }) => SIZE_STYLES[size]}
    ${nonFsStyles}

    ${({ enableGrid }) =>
    enableGrid
      && css`
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: 70px auto 90px;

        & > ${StyledDialogSecondaryContent} {
          grid-row: 1 / 4;
          grid-column: 2 / 2;
        }
      `}
  `}

  ${breakpoint('largeDesktop')`
    height: auto;
    margin-top: unset;
    margin-bottom: auto;
    max-height: calc(100% - 65px);

    ${({ size }) => SIZE_STYLES_LARGE_DESKTOP[size]}
  `}
`;

export const StyledHeaderContent = styled.div`
  flex-grow: 1;

  text-align: center;

  ${breakpoint('desktop')`
    text-align: left;
  `}
`;

export const StyledHeaderCloseButton = styled(FontAwesomeIcon)`
  font-size: 24px;
  font-weight: normal;
  cursor: pointer;

  color: ${theme.colors.aquaMarine};

  ${breakpoint('desktop')`
    color: ${theme.colors.darkBlue};
  `}
`;

export const StyledDialogSecondaryContent = styled.div`
  display: flex;

  min-height: 380px;

  background: ${theme.colors.formSeparator};
  border-bottom: 1px solid ${theme.colors.formSeparator};

  ${breakpoint('desktop')`
    min-height: unset;
  `}
`;

export const StyledDualContentWrapper = styled.div`
  overflow-y: auto;
  max-height: 100%;

  ${StyledDialogContent} {
    overflow-y: visible;
  }
`;
